import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Translation from '../controls/Translation';
import { authHeader } from '../../helpers/auth-header';
import { useCallback } from 'react';

const Insurance = prop => {
    let { supplierDetails, handleChange, formatDateDefault, updateDetailsPermission } = prop;
    const [activeTab, setActiveTab] = useState('insurance-tab-0');
    const [insuranceTabList, setInsuranceTabList] = useState([]);

    const toggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);

            var insuranceTab = document.getElementById('insurance-tab-select');
            if (insuranceTab !== null) {
                insuranceTab.value = tab;
            }
        }
    }

    const handleKeyDown = (e, index) => {
        const enabledTabs = Object.entries(insuranceTabList).filter(([key, tab]) => tab.active);
        const totalTabs = enabledTabs.length;

        let newIndex = null;

        if (e.key === 'ArrowRight') {
            newIndex = (index + 1) % totalTabs;
        } else if (e.key === 'ArrowLeft') {
            newIndex = (index - 1 + totalTabs) % totalTabs;
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();

            // Build panel ID based on index (assuming your section IDs follow insurance-section-{index})
            const panelId = `insurance-section-${index}`;
            const panel = document.getElementById(panelId);
            if (panel) {
                panel.focus();
            }
            return;
        }

        if (newIndex !== null) {
            e.preventDefault();

            // Get new tab's tabName from your insuranceTabList
            const newTabEntry = enabledTabs[newIndex];
            const newTabId = newTabEntry[1].tabName; // Like "insurance-tab-1", etc.

            toggle(newTabId);

            // Move focus to new tab button
            const newTabEl = document.getElementById(newTabId);
            if (newTabEl) {
                newTabEl.focus();
            }
        }
    };


    useEffect(() => {

        fetch(`./Suppliers/GetInsuranceTabList`, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => response.json())
            .then(data => {
                setInsuranceTabList(data);
            })
            .catch(err => {
                console.log(err);
            });
    }, [])

    const handleTabMenu = useCallback((tabMenu, event) => {
        if (tabMenu && event.target.value) {
            tabMenu.querySelector('#' + event.target.value).click();
        }
    }, []);


    useEffect(() => {
        if (Object.keys(insuranceTabList).length > 0) {
            const tabInsuranceSelect = document.querySelector('.js-insurance-tab-select');
            const tabInsuranceMenu = document.querySelector('.' + tabInsuranceSelect.dataset.tabTarget);

            tabInsuranceSelect.addEventListener('change', event => {
                handleTabMenu(tabInsuranceMenu, event);
            });

            return function cleanup() {
                window.removeEventListener('change', handleTabMenu());
            }
        }
    }, [handleTabMenu, insuranceTabList]);

    if (Object.keys(insuranceTabList).length > 0) {
        return (
            <>
                <div className="c-tab-select">
                    <label className="c-tab-select__label" htmlFor="tab-select">Insurance View:</label>
                    <select id="insurance-tab-select" className="c-tab-select__select js-insurance-tab-select" data-tab-target="js-insurance-tabs" defaultValue={activeTab}>
                        {Object.entries(insuranceTabList).map((insurance, i) => {
                            if (insurance[1].active) {
                                return (
                                    <option key={i} value={insurance[1].tabName} >{`${insurance[0]}`}</option>)
                            } else {
                                return null;
                            }
                        })}
                    </select>
                </div>

                <div className='tabs'>
                    <Nav tabs className="js-insurance-tabs" role="tablist">
                        {Object.entries(insuranceTabList).map((insurance, i) => {
                            if (insurance[1].active) {
                                return (
                                    <NavItem key={i} role="presentation">
                                        <NavLink
			                                role='tab'
                                            className={classnames({ active: activeTab === `${insurance[1].tabName}` })}
                                            id={`${insurance[1].tabName}`}
                                            data-toggle='tab'
                                            href={`#insurance-section-${i}`}
                                            aria-label={`${insurance[0].toLowerCase()}`}
                                            onClick={(e) => { e.preventDefault(); toggle(`${insurance[1].tabName}`); }}
                                            {...(activeTab === `${insurance[1].tabName}`
                                                ? { 'aria-selected': 'true' }
                                                : { tabIndex: -1 })}
                                            onKeyDown={(e) => handleKeyDown(e, i)}
                                        >
                                            {`${insurance[0]}`}
                                        </NavLink>
                                    </NavItem>
                                )
                            } else {
                                return null;
                            }
                        })}
                    </Nav>
                </div>

                <TabContent activeTab={activeTab}>
                    <TabPane id='insurance-section-0' role="tabpanel" aria-labelledby="insurance-tab-0" {...(activeTab !== 'insurance-tab-0' && { hidden: true })} tabIndex="-1" tabId='insurance-tab-0'>
                        <div className='tab-pane__inner top'>
                            <div className='c-form'>
                                <h4><Translation ID="EmployerInsurance" /></h4>
                                <div className='c-form__input-group'>
                                    <Translation ID="Insurer" htmlFor='empInsurer' />
                                    <input name='empInsurer' id='empInsurer' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.empInsurer} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceNumber" htmlFor='empLiabilityPolicy' />
                                    <input name='empLiabilityPolicy' id='empLiabilityPolicy' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.empLiabilityPolicy} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceStartDate" htmlFor='empLiabilityStart' />
                                    <input id="empLiabilityStart" name="empLiabilityStart" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.empLiabilityStart)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceEndDate" htmlFor='empLiabilityEnd' />
                                    <input id="empLiabilityEnd" name="empLiabilityEnd" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.empLiabilityEnd)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValuePerEvent" htmlFor='empLiabilityValue' />
                                    <input name='empLiabilityValue' id='empLiabilityValue' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.empLiabilityValue} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValueAggregated" htmlFor='empLiabilityValueAgg' />
                                    <input name='empLiabilityValueAgg' id='empLiabilityValueAgg' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.empLiabilityValueAgg} onChange={(e) => handleChange(e)} />
                                </div>

                            </div>
                        </div>
                    </TabPane>
                    <TabPane id='insurance-section-1' role="tabpanel" aria-labelledby="insurance-tab-1" {...(activeTab !== 'insurance-tab-1' && { hidden: true })} tabIndex="-1" tabId='insurance-tab-1'>
                        <div className='tab-pane__inner'>
                            <div className='c-form'>
                                <h4><Translation ID="PublicLiabilityInsurance" /></h4>
                                <div className='c-form__input-group'>
                                    <Translation ID="Insurer" htmlFor='publicInsurer' />
                                    <input name='publicInsurer' id='publicInsurer' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.publicInsurer} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceNumber" htmlFor='publicLiabilityPolicy' />
                                    <input name='publicLiabilityPolicy' id='publicLiabilityPolicy' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.publicLiabilityPolicy} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceStartDate" htmlFor='publicLiabilityStart' />
                                    <input id="publicLiabilityStart" name="publicLiabilityStart" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.publicLiabilityStart)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceEndDate" htmlFor='publicLiabilityEnd' />
                                    <input id="publicLiabilityEnd" name="publicLiabilityEnd" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.publicLiabilityEnd)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValuePerEvent" htmlFor='publicLiabilityValue' />
                                    <input name='publicLiabilityValue' id='publicLiabilityValue' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.publicLiabilityValue} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValueAggregated" htmlFor='publicLiabilityValueAgg' />
                                    <input name='publicLiabilityValueAgg' id='publicLiabilityValueAgg' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.publicLiabilityValueAgg} onChange={(e) => handleChange(e)} />
                                </div>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane id='insurance-section-2' role="tabpanel" aria-labelledby="insurance-tab-2" {...(activeTab !== 'insurance-tab-2' && { hidden: true })} tabIndex="-1" tabId='insurance-tab-2'>
                        <div className='tab-pane__inner'>
                            <div className='c-form'>
                                <h4><Translation ID="ProfessionalIndemnityInsurance" /></h4>
                                <div className='c-form__input-group'>
                                    <Translation ID="Insurer" htmlFor='profIndemInsurer' />
                                    <input name='profIndemInsurer' id='profIndemInsurer' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.profIndemInsurer} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceNumber" htmlFor='profIndemPolicy' />
                                    <input name='profIndemPolicy' id='profIndemPolicy' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.profIndemPolicy} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceStartDate" htmlFor='profIndemStart' />
                                    <input id="profIndemStart" name="profIndemStart" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.profIndemStart)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceEndDate" htmlFor='profIndemEnd' />
                                    <input id="profIndemEnd" name="profIndemEnd" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.profIndemEnd)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValuePerEvent" htmlFor='profIndemValue' />
                                    <input name='profIndemValue' id='profIndemValue' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.profIndemValue} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValueAggregated" htmlFor='profIndemValueAgg' />
                                    <input name='profIndemValueAgg' id='profIndemValueAgg' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.profIndemValueAgg} onChange={(e) => handleChange(e)} />
                                </div>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane id='insurance-section-3' role="tabpanel" aria-labelledby="insurance-tab-3" {...(activeTab !== 'insurance-tab-3' && { hidden: true })} tabIndex="-1" tabId='insurance-tab-3'>
                        <div className='tab-pane__inner'>
                            <div className='c-form'>
                                <h4><Translation ID="CARLIInsurance" /></h4>
                                <div className='c-form__input-group'>
                                    <Translation ID="Insurer" htmlFor='carliInsurer' />
                                    <input name='carliInsurer' id='carliInsurer' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.carliInsurer} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceNumber" htmlFor='carliLiabilityNumber' />
                                    <input name='carliLiabilityNumber' id='carliLiabilityNumber' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.carliLiabilityNumber} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceStartDate" htmlFor='carliStartDate' />
                                    <input id="carliStartDate" name="carliStartDate" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.carliStartDate)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceEndDate" htmlFor='carliEndDate' />
                                    <input id="carliEndDate" name="carliEndDate" className="c-form__input" disabled={!updateDetailsPermission} type="date" autoComplete="false" defaultValue={formatDateDefault(supplierDetails.carliEndDate)} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValuePerEvent" htmlFor='carliValuePerEvent' />
                                    <input name='carliValuePerEvent' id='carliValuePerEvent' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.carliValuePerEvent} onChange={(e) => handleChange(e)} />
                                </div>
                                <div className='c-form__input-group'>
                                    <Translation ID="InsuranceValueAggregated" htmlFor='carliValueAggregated' />
                                    <input name='carliValueAggregated' id='carliValueAggregated' type='text' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.carliValueAggregated} onChange={(e) => handleChange(e)} />
                                </div>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane id='insurance-section-4' role="tabpanel" aria-labelledby="insurance-tab-4" {...(activeTab !== 'insurance-tab-4' && { hidden: true })} tabIndex="-1" tabId='insurance-tab-4'>
                        <div className='tab-pane__inner'>
                            <div className='c-form'>
                                <h4><Translation ID="OtherInsturances" /></h4>

                                <div className='c-form__input-group'>
                                    <Translation ID="OtherInsturances" htmlFor='otherInsurances' />
                                    <input name='otherInsurances' id='otherInsurances' type='textarea' className='c-form__input' disabled={!updateDetailsPermission} defaultValue={supplierDetails.otherInsurances} onChange={(e) => handleChange(e)} />
                                </div>
                            </div>
                        </div>
                    </TabPane>
                </TabContent>
            </>
        );
    } else {
        return (<></>);
    }
}

export default Insurance;